import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Module, SubModule } from './rbac.models';
import { ModuleManagementComponent } from './module-management/module-management.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { SubModuleManagementComponent } from './submodule-management/submodule-management.component';
import { InnerModuleManagementComponent } from './innermodule-management/innermodule-management.component';

type RbacTab = 'roles' | 'modules' | 'submodules' | 'innermodules';

/**
 * Top-level RBAC screen: tabs for Roles / Modules.
 * Sub-Modules and Inner Modules are reached by drilling down
 * through row clicks — not visible as separate tabs.
 */
@Component({
  selector: 'app-rbac-shell',
  standalone: true,
  imports: [
    CommonModule,
    RoleManagementComponent,
    ModuleManagementComponent,
    SubModuleManagementComponent,
    InnerModuleManagementComponent
  ],
  templateUrl: './rbac-shell.component.html',
  styleUrls: ['./rbac-shell.component.scss']
})
export class RbacShellComponent {
  activeTab: RbacTab = 'modules';
  selectedModule: Module | null = null;
  selectedSubModule: SubModule | null = null;

  tabs: { key: RbacTab; label: string }[] = [
    { key: 'modules', label: 'Modules' },
    { key: 'roles', label: 'Roles' }
  ];

  setTab(tab: RbacTab): void {
    this.activeTab = tab;
    if (tab !== 'submodules' && tab !== 'innermodules') {
      this.selectedModule = null;
      this.selectedSubModule = null;
    }
  }

  openSubModules(module: Module): void {
    this.selectedModule = module;
    this.selectedSubModule = null;
    this.activeTab = 'submodules';
  }

  backToModules(): void {
    this.activeTab = 'modules';
    this.selectedModule = null;
    this.selectedSubModule = null;
  }

  openInnerModules(subModule: SubModule): void {
    this.selectedSubModule = subModule;
    this.activeTab = 'innermodules';
  }

  backToSubModules(): void {
    this.activeTab = 'submodules';
    this.selectedSubModule = null;
  }
}
